import { FC } from "react";
import DatePicker from "react-datepicker";
import { CLAIM_STATUS, CopaylaimsFilterProps } from "./types";
import { format } from "date-fns";
import { offset, shift, limitShift } from "@floating-ui/react";
import { ClaimQueryStateActions } from "src/pages/copayClaimsHCP/types";
import Select from "react-select";


const CopayFilter: FC<CopaylaimsFilterProps> = ({ state, dispatch, handleSearchWithQueryParam, onClearButtonClicked, activeTabName }): JSX.Element => {

  const handleDateFromChange = (date: Date | null): void => {
    dispatch && dispatch({
      type: ClaimQueryStateActions.CHANGE_START_DATE,
      payload: date ? format(date, "MM/dd/yyyy") : "",
    });
  };

  const handleDateToChange = (date: Date | null) => {
    dispatch && dispatch({
      type: ClaimQueryStateActions.CHANGE_END_DATE,
      payload: date ? format(date, "MM/dd/yyyy") : "",
    });
  };

  // const handleSearchQueryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //  dispatch && dispatch({
  //     type: ClaimQueryStateActions.CHANGE_SEARCH_QUERY,
  //     payload: e.target.value
  //   });
  //   console.log("handleSearchQueryChange....",)
  // };
  const handleSearchQueryChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: "case_id" | "patient_name" | "claim_status" | "days_left"
  ) => {
    console.log("Field.....", field)
    if (field === "case_id") {
      dispatch({
        type: ClaimQueryStateActions.CHANGE_CASE_ID,
        payload: e.target.value
      });
    } else if (field === "patient_name") {
      dispatch({
        type: ClaimQueryStateActions.CHANGE_PATIENT_NAME,
        payload: e.target.value
      });
    } else if (field === "claim_status") {
      dispatch({
        type: ClaimQueryStateActions.CHANGE_CLAIM_STATUS,
        payload: e.target.value
      });
    }
    else if (field === "days_left") {
      dispatch({
        type: ClaimQueryStateActions.CHANGE_DAYS_LEFT,
        payload: Number(e.target.value)
      });
    }

  };

  const parseSearchQueries = () => {
    dispatch && dispatch({ type: ClaimQueryStateActions.CHANGE_PAGE, payload: 1, });
    const updatedState = { ...state, page: 1 };
    // if (state?.start_date && state.start_date.length > 0)
    //   updatedState.start_date = format(parse(state.start_date, "MM/dd/yyyy", new Date()), "yyyy-MM-dd")
    // if (state?.end_date && state.end_date.length > 0)
    //   updatedState.end_date = format(parse(state?.end_date, "MM/dd/yyyy", new Date()), "yyyy-MM-dd")
    // console.log({ updatedState })
    handleSearchWithQueryParam && handleSearchWithQueryParam(state);
  }

  const onEnterPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      parseSearchQueries()
    }
  }


  const updateCaseFilters = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    parseSearchQueries()
  }

  return (
    <form onSubmit={updateCaseFilters} className="row g-2 statistics-filter" data-tour="third-step">
      <div className="col date-field">
        <DatePicker
          selected={state?.start_date ? new Date(state?.start_date) : null} // Ensure correct date format
          onChange={(date) => handleDateFromChange(date)} // Pass Date | null directly
          className="form-control"
          wrapperClassName="w-100"
          placeholderText="mm/dd/yyyy"
          showMonthDropdown
          showYearDropdown
          maxDate={state?.end_date ? new Date(state?.end_date) : undefined}
          isClearable
          portalId="root"
          popperModifiers={[offset(8), shift({ limiter: limitShift() })]}
        />
      </div>
      <div className="col date-field">
        <DatePicker
          selected={state?.end_date ? new Date(state?.end_date) : null} // Use selected instead of value
          onChange={(date) => handleDateToChange(date)} // Pass Date | null directly
          className="form-control"
          wrapperClassName="w-100"
          placeholderText="mm/dd/yyyy"
          showMonthDropdown
          showYearDropdown
          minDate={state?.start_date ? new Date(state?.start_date) : undefined}
          isClearable
          portalId="root"
          popperModifiers={[offset(8), shift({ limiter: limitShift() })]}
        />
      </div>
      <div className="col copay-patient-col">
        <input type="text"
          onChange={(e) => handleSearchQueryChange(e, "case_id")}
          value={state?.case_id || ""}
          placeholder={"Search By Case ID"}
          className="form-control"
          onKeyDown={onEnterPress} />
      </div>
      {activeTabName?.label === "All Enrollments" ? <div className="col copay-patient-col">
        <input type="text"
          onChange={(e) => handleSearchQueryChange(e, "patient_name")}
          value={state?.patient_name || ""}
          placeholder={"Search By Patient Name"}
          className="form-control"
          onKeyDown={onEnterPress} />
      </div>
        :
        <div className="col copay-patient-col">
          <Select
            inputId="claim_status"
            placeholder="Select Claim Status"
            isClearable
            isSearchable={false}
            options={CLAIM_STATUS}
            value={
              state.claim_status
                ? CLAIM_STATUS.find(
                  (option) => option.value === state.claim_status
                )
                : null
            }
            onChange={(option) =>
              dispatch({
                type: ClaimQueryStateActions.CHANGE_CLAIM_STATUS,
                payload: option?.value || ""
              })

            }
          />
        </div>}
      {activeTabName?.label === "All Enrollments" &&
        <div className="col search-col">
          <input
            type="number"
            onChange={(e) => {
              const value = Number(e.target.value);

              // ❌ block 0 and negative numbers
              if (value < 0) return;

              handleSearchQueryChange(e, "days_left");
            }}
            value={state?.days_left ?? ""}   // ✅ FIX: use ?? not ||
            placeholder="Search By Days Left"
            className="form-control"
            onKeyDown={onEnterPress}
          />
        </div>}
      <div className="col date-col d-flex gap-2">
        <button type="submit" className="btn btn-primary w-100">Find</button>
        <button type="button" onClick={onClearButtonClicked} className="btn btn-outline-secondary w-100">Clear</button>
      </div>
    </form>
  );
};

export default CopayFilter;
